import { useTheme } from '@mui/material/styles';

export const useIdScanStyles = () => {
  const theme = useTheme();
  return {
    container: {
      position: 'relative',
      height: '100%',
    },
    backButton: {
      backgroundColor: '#888',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#444',
      },
    },
    scanTipWrapper: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(2),
    },
    scanTip: {
      color: '#444',
      paddingTop: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    scanTipTitle: {
      fontSize: '14px',
      fontWeight: 700,
    },
    scanTipDesc: {
      fontSize: '13px',
      fontWeight: 400,
      paddingTop: theme.spacing(1),
    },
    videoContainer: {
      margin: '16px',
      minHeight: '80px',
      borderRadius: '4px',
      overflow: 'hidden',
    },
    video: {
      width: '100%',
      display: 'block',
    },
    buttonContainer: {
      width: '100%',
    },
    button: {
      borderRadius: '40px',
      textTransform: 'initial',
      fontWeight: 600,
      boxShadow: 'none',
      display: 'inline-flex',
      alignItems: 'baseline',
    },
    cantscanButton: {
      color: '#fff',
      width: '100%',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      bottom: theme.spacing(2),
    },
    tipContainer: {
      padding: '0px 10px',
    },
    tipText: {
      fontWeight: 600,
    },
    exampleImage: {
      maxWidth: '480px',
      width: '100%',
    },
    dialogSecondaryText: {
      color: '#878687',
      paddingTop: '10px',
      fontSize: '13px',
    },
    dialogButtonWrapper: {
      marginTop: theme.spacing(5),
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    dialogButtonWrapperSecondary: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    dobText: {
      fontWeight: 600,
    },
    ageLimitText: {
      fontWeight: 600,
    },
  };
};

